import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { setupPerformanceMonitoring, mark } from './utils/performance'
import { setupGlobalErrorHandler } from './utils/error-handler'

// Element Plus 优化：不再全局注册，改为按需导入
// 由于只使用了 ElMessage，移除全局注册可以大幅减少 bundle 大小
// 各组件需要时直接导入：import { ElMessage } from 'element-plus'

// MathJax 延迟加载 - 只在需要数学公式的页面加载
// 从立即加载改为按需加载，节省首次加载时间
let mathJaxLoadPromise = null
async function ensureMathJax() {
  if (window.MathJax && window.MathJax.typesetPromise) return
  
  // 如果已经在加载中，返回同一个 promise
  if (mathJaxLoadPromise) return mathJaxLoadPromise
  
  mathJaxLoadPromise = (async () => {
    try {
      await import('mathjax/es5/tex-chtml.js')
      return
    } catch (e) {}
    const cdns = [
      'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js',
      'https://unpkg.com/mathjax@3/es5/tex-chtml.js',
      'https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.2.2/es5/tex-chtml.min.js'
    ]
    await new Promise((resolve, reject) => {
      let i = 0
      function tryLoad() {
        if (i >= cdns.length) {
          reject(new Error('MathJax load failed'))
          return
        }
        const s = document.createElement('script')
        s.src = cdns[i++]
        s.async = true
        s.onload = () => resolve()
        s.onerror = tryLoad
        document.head.appendChild(s)
      }
      tryLoad()
    })
  })()
  
  return mathJaxLoadPromise
}

// 导出 MathJax 加载函数，供需要数学公式的组件使用
export { ensureMathJax }

// Start performance monitoring
mark('app-init-start')
setupPerformanceMonitoring()

// Setup global error handler
setupGlobalErrorHandler((errorInfo) => {
  // 在生产环境中，可以显示用户友好的错误提示
  console.error('Application error:', errorInfo)
})

// MathJax 不再在启动时加载，改为按需加载
// 只在包含数学公式的页面（如 Toy 详情页）加载
// ensureMathJax() // 已移除，改为按需加载

const app = createApp(App)

// Vue 错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err, info)
  // 可以在这里显示错误提示
}

app.use(router)

// Element Plus 不再全局注册，改为按需导入
// 这样可以大幅减少首次加载的 bundle 大小
// 各组件需要时直接导入：import { ElMessage } from 'element-plus'

mark('app-mount-start')
app.mount('#app')
mark('app-mount-end')
